/**
 * Utils with no dependencies.
 */

module.exports = {
    /**
     * @function
     * @description Extracts all parameters from a given query string into an object
     * @param {String} qs The query string from which the parameters will be extracted
     */
    getQueryStringParams: function (qs) {
        var params = {};
        var unescapedQS;
        if (!qs || qs.length === 0) {
            return {};
        }
        unescapedQS = decodeURIComponent(qs);
        // Use the String::replace method to iterate over each
        // name-value pair in the string.
        unescapedQS.replace(new RegExp('([^?=&]+)(=([^&]*))?', 'g'), function ($0, $1, $2, $3) {
            params[$1] = $3.replace('+', ' ');
        });
        return params;
    },

    objectToQueryString: function (params) {
        var arr = [];
        for (var p in params) {
            arr.push(encodeURIComponent(p) + '=' + encodeURIComponent(params[p]));
        }

        return arr.join('&');
    },

    /**
     * Get current location without parameters or hash.
     * @return {string} The stripped url.
     */
    getBaseUrl: function () {
        return window.location.protocol + '//' + window.location.hostname + window.location.pathname;
    },

    /**
     * Format a number with a specific thousand separator and a specific decimal point.
     * @example formatLocale(10000000000.55, ',') -> '10,000,000,000.55'
     *          formatLocale(10000000000.55, '.') -> '10.000.000.000,55'
     *          formatLocale(25, '.', 2)          -> '25,00'
     *
     * @param {Number} number The number to format.
     * @param {String} separator The thousands separator.
     * @param {Number} decimals The number of decimals to show.
     * @param {String} prefix A character to prefix the number with.
     * @param {String} suffix A character to suffix the number with.
     * @return {String} The formatted number.
     */
    formatLocale: function (number, separator, decimals, prefix, suffix) {
        var decimal = separator === ',' ? '.' : ',';
        var numberString = typeof decimals !== 'undefined' ? number.toFixed(decimals) : number.toString();
        var num = numberString.split('.')[0];
        var dec = numberString.split('.')[1];
        return (
            (prefix || '') +
            num.replace(/\B(?=(\d{3})+(?!\d))/g, separator) +
            (dec ? decimal + dec : '') +
            (suffix || '')
        );
    },

    /**
     * Find the format of a currency number like "$10,000.00" or "10.000,00 €"
     * @param {String} str The currency number as a string.
     * @return {{currencyChar: *, decimalChar: (string), separator: *, currencyPosition: (string)}}
     */
    getCurrencyFormatFromString: function (str) {
        var separator = (str.match(/[\.\,]+/) || [])[0];
        var decimalChar = separator && separator === '.' ? ',' : '.';
        var currencyChar = (str.match(/[^\d\.,]+/) || [])[0];
        var currencyPosition = str.match(/^\D/) ? 'before' : 'after';

        return {
            separator: separator,
            decimalChar: decimalChar,
            currencyChar: currencyChar,
            currencyPosition: currencyPosition
        };
    },

    /**
     * Simple hash function
     * @param {String} str The currency number as a string.
     * @return {String} The hashed string
     */
    hash: function (str) {
        var hash = 0;
        if (str.length == 0) {
            return hash;
        }
        for (var i = 0; i < str.length; i++) {
            var char = str.charCodeAt(i);
            hash = (hash << 5) - hash + char;
            hash = hash & hash; // Convert to 32bit integer
        }
        return hash;
    }
};
